import React from "react";
import { Link } from "react-router-dom";

const JOURNAL_IMG = "https://customer-assets.emergentagent.com/job_voyage-ia-1/artifacts/nqju529j_20260505_175212.jpg";

export default function LandingAbout() {
  return (
    <section className="py-20 max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-2 gap-12 items-center">

        {/* Journal image */}
        <div>
          <div className="bg-[#F9F6F0] p-4 pb-12 border border-[#DCD4C6] shadow-md sm:transform sm:rotate-1 hover:rotate-0 transition-transform">
            <img
              src={JOURNAL_IMG}
              alt="Journal de voyage et appareil photo"
              className="w-full h-[280px] object-cover"
              loading="lazy"
            />
            <p className="mt-3 text-center text-sm text-[#8B5E34]" style={{ fontFamily: "'Caveat', cursive", fontSize: "1rem" }}>
              Quelque part en Afrique australe
            </p>
          </div>
        </div>

        {/* Text */}
        <div className="animate-fade-in-up">
          <p className="section-label mb-4">Votre expert</p>
          <h2
            className="text-4xl sm:text-5xl mb-6"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#2B2623" }}
          >
            Un vrai passionné<br />
            <span className="italic" style={{ color: "#C17F59" }}>derrière chaque voyage</span>
          </h2>
          <blockquote
            className="text-lg text-[#5C554E] mb-6 pl-4 border-l-2 border-[#C17F59] italic leading-relaxed"
            style={{ fontFamily: "'Lora', Georgia, serif" }}
          >
            « Tout a commencé les pieds nus sur les pistes africaines. J'ai grandi avec l'horizon pour seule limite. »
          </blockquote>
          <p className="text-sm text-[#5C554E] mb-8 leading-relaxed" style={{ fontFamily: "'Lora', Georgia, serif" }}>
            Bénin, Réunion, Maroc, Madagascar — j'ai passé ma vie à explorer. Aujourd'hui, je mets toute cette expérience au service de vos aventures.
          </p>
          <Link to="/about" className="btn-secondary text-sm" data-testid="about-teaser-btn">
            Lire mon histoire
          </Link>
        </div>

      </div>
    </section>
  );
}
